import GmapVue from 'gmap-vue';
import Vue from 'vue'


Vue.use(GmapVue, {
    load: {
        key: document.head.querySelector('meta[name="gmaps-key"]')?.content,
        libraries: 'places',
    }
})